<page-title title="Horário de Atendimento"></page-title>

<div>
  <page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
  <page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>
  <page-alert [message]="messageWarning" *ngIf="showWarningMessage" alertClass="alert-warning"></page-alert>

  <div *ngFor="let day of [1, 2, 3, 4, 5, 6, 0]" class="day-section">
    <h3 class="day-title">{{ getDayOfWeekName(day) }}</h3>

    <div *ngFor="let horario of getHoursForDay(day); let idx = index">
      <div class="row horarios">
        <div class="col-xs-12 col-sm-8">
          <mat-form-field appearance="outline">
            <mat-label>Início do atendimento</mat-label>
            <input
              matInput
              type="time"
              [(ngModel)]="horario.timeStart"
              (ngModelChange)="onChangeForm()"
              placeholder="Atendimento a partir de"
            />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Fim do atendimento</mat-label>
            <input
              matInput
              type="time"
              [(ngModel)]="horario.timeEnd"
              (ngModelChange)="onChangeForm()"
              placeholder="Atendimento até"
            />
          </mat-form-field>

          <mat-error *ngIf="!hasRightTime(horario)" align="left">
            Horário de início deve ser anterior ao horário de término.
          </mat-error>

          <mat-error *ngIf="hasOverlapOnDay(day)" align="left">
            Horários sobrepostos neste dia. Por favor, corrija-os.
          </mat-error>
        </div>
        <div class="col-xs-12 col-sm-4 btRmv">
          <button type="button" mat-raised-button color="warn" (click)="removeTime(idx, day)">Remover</button>
        </div>
      </div>
    </div>

    <div class="col-xs-12 add-button-container">
      <button type="button" mat-raised-button color="primary" (click)="addDayOfWeekTime(day)">
        Adicionar horário <span class="hidden-xs">para este dia</span>
      </button>
    </div>

    <mat-divider></mat-divider>
  </div>
</div>

<div class="col-xs-12 actions">
  <button
    mat-flat-button
    color="primary"
    [disabled]="!isObjectFilled(location) || !validateForm() || loading"
    [title]="showErrorMessage ?  'Corrija seus horários' : 'Clique aqui para salvar' "
    (click)="salvar()"
  >
    {{ loading ? 'Salvando...' : 'Salvar' }}
  </button>
</div>
